import { useMemo } from 'react';
import { Language } from '@/api/types';

/**
 * Derives the applicant-selectable languages from any positions-like list
 * (each item just needs a `languages` array). Used by the apply form
 * (property positions) and the client locations page (positions flattened
 * across properties), so both stay in agreement with the language screen.
 */
export const useAvailableLanguages = (
  positions?: ReadonlyArray<{ languages: Language[] }>
): Language[] =>
  useMemo(() => {
    if (!positions) return [];
    const languages = [
      ...new Set(positions.flatMap((position) => position.languages ?? [])),
    ];
    return languages.length === 0 ? ['english'] : languages;
  }, [positions]);
